import React, { useCallback, useState } from "react";
import { Task, TaskType } from "../../../types";
import { Button } from "@bandit-network/react-ui-kit";
import {
  CheckCircledIcon,
  ExternalLinkIcon,
  ReloadIcon,
} from "@radix-ui/react-icons";
import { getTarget, getUrl } from "../../../utils";
import { useQuestContext } from "../../../context/QuestContext";
import { replaceHyperlinks } from "../../../utils/hyperlink";
import { useConnect } from "@bandit-network/react-wallet-kit";
import useUser from "../../../hooks/useUser";

export interface PostProps {
  data: Task;
}

const Post: React.FC<PostProps> = ({ data }) => {
  const [isVisited, setIsVisited] = useState(false);
  const { tasksCompleted, questSDK } = useQuestContext();
  const { signature, address } = useConnect();
  const { user, onXConnect, isUserLoading, showRefresh, fetchUser } = useUser();

  const post = useCallback(async () => {
    setIsVisited(true);
    await questSDK.saveTwitterPerformTask({
      walletAddress: address,
      signature: signature.data,
      taskId: data?.id,
    });
    setTimeout(() => {
      window.open(
        getUrl(TaskType.X_POST, data.args.twitterTweet),
        getTarget(),
        "height=600,width=600",
      );
    }, 100);
    setTimeout(() => {
      setIsVisited(false);
    }, 7500);
  }, [data, signature]);

  const isTaskComplete = tasksCompleted.includes(data?.id);
  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      {user?.socialmedia?.twitter ? (
        <Button
          size="sm"
          className="bad-quest__task--action_button"
          onClick={post}
          disabled={isTaskComplete || isVisited}
        >
          {isTaskComplete
            ? `Completed`
            : isVisited
              ? "Posting..."
              : `Post on X`}
          {isTaskComplete ? (
            <CheckCircledIcon className="bad-quest__task--check_icon" />
          ) : null}
        </Button>
      ) : (
        <div className="flex items-center">
          <Button
            size="sm"
            className="bad-quest__task--action_button"
            onClick={onXConnect}
            disabled={isTaskComplete || !signature?.data || isUserLoading}
          >
            {isUserLoading ? `Connecting...` : `Connect X`}
          </Button>
          {showRefresh && (
            <ReloadIcon
              className={`ml-2 mt-2 cursor-pointer bad-quest_action_button-reload${
                !isUserLoading ? "-stop" : ""
              }`}
              onClick={fetchUser}
            />
          )}
        </div>
      )}
    </div>
  );
};

export { Post };
